/**
 * 描述：审计管理 和 审计任务
 * 录入人： 张磊
 */
import request from '../request.js'
/**
 * 描述：我的委托 - 分页查询 - 列表数据
 * author：郑志会
 * 
 */
export const selectPagEentrust = function (data) {
    return request({
        url: 'busTaskAudit/selectPagEentrust',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
 * 描述： 我的委托 - 修改 - 确认修改保存
 * author： 郑志会
 * 参数： 
 {
    id： "",
    packId: "", //标段id
 }
 */

export const getModifyAdd = function (data) {
    return request({
        url: 'busTaskAudit/getModifyAdd',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
 * 描述： 我的委托 - 撤回 - 确认保存
 * author： 郑志会
 * 参数： 
 {
    id： "",
    status:'',
    remark:''
 }
 */
export const getWithdrawAdd = function (data) {
    return request({
        url: 'busTaskAudit/getWithdrawAdd',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
 * 描述： 我的委托 - 作废记录 - 查看详情
 * author： 郑志会
 * 参数： 
 {
    id： "",
 }
 */
export const getWithdrawInfo = function (data) {
    return request({
        url: '/busTaskAudit/getWithdrawInfo',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}